import { useEffect, useMemo, useRef } from "react";
import type { Notify } from "./admin-types";

/** Sekiz yönetici ekranının ortak istek ömrü; sunucu yetkilendirmesi değildir. */
export function useAdminRequestScope(notify: Notify) {
  const state = useRef({mounted: true, generation: 0, notify});
  state.current.notify = notify;
  useEffect(() => {
    state.current.mounted = true;
    return () => {state.current.mounted = false; state.current.generation++;};
  }, []);
  return useMemo(() => ({
    isMounted: () => state.current.mounted,
    beginRead: () => ++state.current.generation,
    invalidateReads: () => {state.current.generation++;},
    isCurrentRead: (generation: number) => state.current.mounted && generation === state.current.generation,
    notify: (message: string) => {if (state.current.mounted) state.current.notify(message);},
  }), []);
}
